var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.blackScreen)?_c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sidebar-right",modifiers:{"sidebar-right":true}}],attrs:{"id":"loading"},on:{"click":_vm.hideMenu}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }